const items = [
  '魔性洗脑 越看越上头',
  '今日神展开已上线',
  '爆笑合集 每天不重样',
  '脑洞大开 停不下来',
  '反转剧场 剧情狂飙',
  '恶搞名场面 笑到肚子疼',
  '新作品 10:00 / 18:00 更新',
];

export default function Ticker() {
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-primary-200 bg-accent-400 py-3">
      <div className="flex w-max animate-ticker gap-10">
        {row.map((text, index) => (
          <span key={index} className="flex items-center gap-2 whitespace-nowrap text-sm font-bold text-foreground-950">
            <i className="ri-emotion-happy-line" aria-hidden="true" />
            {text}
          </span>
        ))}
      </div>
    </div>
  );
}